import { render, staticRenderFns } from "./DossierPeppolRegistrationsEdit.vue?vue&type=template&id=64f9d3fb&scoped=true&"
import script from "./DossierPeppolRegistrationsEdit.vue?vue&type=script&lang=ts&"
export * from "./DossierPeppolRegistrationsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f9d3fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f9d3fb')) {
      api.createRecord('64f9d3fb', component.options)
    } else {
      api.reload('64f9d3fb', component.options)
    }
    module.hot.accept("./DossierPeppolRegistrationsEdit.vue?vue&type=template&id=64f9d3fb&scoped=true&", function () {
      api.rerender('64f9d3fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dossier/DossierPeppolRegistrationsEdit.vue"
export default component.exports